import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

export interface TaxingDistrictListGridActionCellRendererParams extends ICellRendererParams {
    canDelete: (params: TaxingDistrictListGridActionCellRendererParams) => boolean;
    delete: (params: TaxingDistrictListGridActionCellRendererParams) => void;
}

@Component({
    selector: 'taxing-district-grid-action-cell',
    template: `
    <button class="ace-btn has-icon btn-primary btn-danger grid-action-button"
        title="Delete"
        [disabled]="!params.canDelete(params)"
        (click)="params.delete(params)"
        helpTooltip
        helpContentId="app.delete"
        position="bottom">
        <i class="fa fa-trash"></i>
    </button>
    `,
    standalone: false
})
export class TaxingDistrictListGridActionCellRendererComponent implements ICellRendererAngularComp {
    params: TaxingDistrictListGridActionCellRendererParams;

    agInit(params: TaxingDistrictListGridActionCellRendererParams): void {
        this.params = params;
    }

    refresh(): boolean {
        return false; // tells grid to handle refreshing
    }
}
